// extracted by mini-css-extract-plugin
export var anchoredNavBar = "NavigationBarStyle-module--anchoredNavBar--84d66";
export var closed = "NavigationBarStyle-module--closed--94d42";
export var freeNavBar = "NavigationBarStyle-module--freeNavBar--57551";
export var fullscreen = "NavigationBarStyle-module--fullscreen--88cb8";
export var hiddenNavBar = "NavigationBarStyle-module--hiddenNavBar--6f30c";
export var homeLink = "NavigationBarStyle-module--homeLink--b2ab7";
export var homeLinkImage = "NavigationBarStyle-module--homeLinkImage--5a36e";
export var link = "NavigationBarStyle-module--link--62d04";
export var slideAnimation = "NavigationBarStyle-module--slide-animation--6cc61";